export default __webpack_public_path__ + "static/media/a8.74921d75.png";